module.exports = __webpack_public_path__ + "assets/phonecall.169fa2ea.png";